/**
 * Copyright (c) 2019 Vendor Badge, LLC All Rights Reserved.
 *
 *  Portal - Company View - TabPanel
 */
import React from 'react';
import PropTypes from 'prop-types';

// Design System
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

function TabLabel(props) {
  const { label, variant, ...rest } = props;
  const classes = styles();

  return (
    <Typography color='textPrimary' variant={variant} className={classes.label} {...rest}>
      {label}
    </Typography>
  );
}

TabLabel.propTypes = {
  label: PropTypes.string.isRequired,
};

const styles = makeStyles(theme => ({
  label: {
    wordWrap: 'break-word',
  },
}));

export default TabLabel;
